/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AuthedRouteImport } from './routes/_authed';
import { Route as publicForgotPasswordRouteImport } from './routes/(public)/forgot-password';
import { Route as publicLoginRouteImport } from './routes/(public)/login';
import { Route as publicMagicLinkRouteImport } from './routes/(public)/magic-link';
import { Route as publicResetPasswordRouteImport } from './routes/(public)/reset-password';
import { Route as publicSignInLinkRouteImport } from './routes/(public)/sign-in-link';
import { Route as AuthedApplicationsRouteImport } from './routes/_authed/applications';
import { Route as AuthedAuditLogRouteImport } from './routes/_authed/audit-log';
import { Route as AuthedDiamondsRouteImport } from './routes/_authed/diamonds';
import { Route as AuthedExchangeRatesRouteImport } from './routes/_authed/exchange-rates';
import { Route as AuthedHelpRouteImport } from './routes/_authed/help';
import { Route as AuthedOperationsRouteImport } from './routes/_authed/operations';
import { Route as AuthedOrganizationsRouteImport } from './routes/_authed/organizations';
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings';
import { Route as AuthedSupportSessionsRouteImport } from './routes/_authed/support-sessions';
import { Route as AuthedUsersRouteImport } from './routes/_authed/users';
import { Route as AuthedAccountSecurityRouteImport } from './routes/_authed/account/security';
import { Route as AuthedApplicationsIndexRouteImport } from './routes/_authed/applications/index';
import { Route as AuthedApplicationsApplicationIdRouteImport } from './routes/_authed/applications/$applicationId';
import { Route as AuthedOrganizationsIndexRouteImport } from './routes/_authed/organizations/index';
import { Route as AuthedOrganizationsOrganizationIdRouteImport } from './routes/_authed/organizations/$organizationId';
import { Route as publicAuthGoogleCallbackRouteImport } from './routes/(public)/auth/google/callback';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any);
const publicForgotPasswordRoute = publicForgotPasswordRouteImport.update({
  id: '/(public)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any);
const publicLoginRoute = publicLoginRouteImport.update({
  id: '/(public)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const publicMagicLinkRoute = publicMagicLinkRouteImport.update({
  id: '/(public)/magic-link',
  path: '/magic-link',
  getParentRoute: () => rootRouteImport,
} as any);
const publicResetPasswordRoute = publicResetPasswordRouteImport.update({
  id: '/(public)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const publicSignInLinkRoute = publicSignInLinkRouteImport.update({
  id: '/(public)/sign-in-link',
  path: '/sign-in-link',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedApplicationsRoute = AuthedApplicationsRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedAuditLogRoute = AuthedAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedDiamondsRoute = AuthedDiamondsRouteImport.update({
  id: '/diamonds',
  path: '/diamonds',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedExchangeRatesRoute = AuthedExchangeRatesRouteImport.update({
  id: '/exchange-rates',
  path: '/exchange-rates',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedHelpRoute = AuthedHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedOperationsRoute = AuthedOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedOrganizationsRoute = AuthedOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedSupportSessionsRoute = AuthedSupportSessionsRouteImport.update({
  id: '/support-sessions',
  path: '/support-sessions',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedAccountSecurityRoute = AuthedAccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedApplicationsIndexRoute = AuthedApplicationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedApplicationsRoute,
} as any);
const AuthedApplicationsApplicationIdRoute =
  AuthedApplicationsApplicationIdRouteImport.update({
    id: '/$applicationId',
    path: '/$applicationId',
    getParentRoute: () => AuthedApplicationsRoute,
  } as any);
const AuthedOrganizationsIndexRoute =
  AuthedOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedOrganizationsRoute,
  } as any);
const AuthedOrganizationsOrganizationIdRoute =
  AuthedOrganizationsOrganizationIdRouteImport.update({
    id: '/$organizationId',
    path: '/$organizationId',
    getParentRoute: () => AuthedOrganizationsRoute,
  } as any);
const publicAuthGoogleCallbackRoute =
  publicAuthGoogleCallbackRouteImport.update({
    id: '/(public)/auth/google/callback',
    path: '/auth/google/callback',
    getParentRoute: () => rootRouteImport,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/forgot-password': typeof publicForgotPasswordRoute;
  '/login': typeof publicLoginRoute;
  '/magic-link': typeof publicMagicLinkRoute;
  '/reset-password': typeof publicResetPasswordRoute;
  '/sign-in-link': typeof publicSignInLinkRoute;
  '/applications': typeof AuthedApplicationsRouteWithChildren;
  '/audit-log': typeof AuthedAuditLogRoute;
  '/diamonds': typeof AuthedDiamondsRoute;
  '/exchange-rates': typeof AuthedExchangeRatesRoute;
  '/help': typeof AuthedHelpRoute;
  '/operations': typeof AuthedOperationsRoute;
  '/organizations': typeof AuthedOrganizationsRouteWithChildren;
  '/settings': typeof AuthedSettingsRoute;
  '/support-sessions': typeof AuthedSupportSessionsRoute;
  '/users': typeof AuthedUsersRoute;
  '/account/security': typeof AuthedAccountSecurityRoute;
  '/applications/$applicationId': typeof AuthedApplicationsApplicationIdRoute;
  '/organizations/$organizationId': typeof AuthedOrganizationsOrganizationIdRoute;
  '/applications/': typeof AuthedApplicationsIndexRoute;
  '/organizations/': typeof AuthedOrganizationsIndexRoute;
  '/auth/google/callback': typeof publicAuthGoogleCallbackRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/forgot-password': typeof publicForgotPasswordRoute;
  '/login': typeof publicLoginRoute;
  '/magic-link': typeof publicMagicLinkRoute;
  '/reset-password': typeof publicResetPasswordRoute;
  '/sign-in-link': typeof publicSignInLinkRoute;
  '/audit-log': typeof AuthedAuditLogRoute;
  '/diamonds': typeof AuthedDiamondsRoute;
  '/exchange-rates': typeof AuthedExchangeRatesRoute;
  '/help': typeof AuthedHelpRoute;
  '/operations': typeof AuthedOperationsRoute;
  '/settings': typeof AuthedSettingsRoute;
  '/support-sessions': typeof AuthedSupportSessionsRoute;
  '/users': typeof AuthedUsersRoute;
  '/account/security': typeof AuthedAccountSecurityRoute;
  '/applications/$applicationId': typeof AuthedApplicationsApplicationIdRoute;
  '/organizations/$organizationId': typeof AuthedOrganizationsOrganizationIdRoute;
  '/applications': typeof AuthedApplicationsIndexRoute;
  '/organizations': typeof AuthedOrganizationsIndexRoute;
  '/auth/google/callback': typeof publicAuthGoogleCallbackRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/_authed': typeof AuthedRouteWithChildren;
  '/(public)/forgot-password': typeof publicForgotPasswordRoute;
  '/(public)/login': typeof publicLoginRoute;
  '/(public)/magic-link': typeof publicMagicLinkRoute;
  '/(public)/reset-password': typeof publicResetPasswordRoute;
  '/(public)/sign-in-link': typeof publicSignInLinkRoute;
  '/_authed/applications': typeof AuthedApplicationsRouteWithChildren;
  '/_authed/audit-log': typeof AuthedAuditLogRoute;
  '/_authed/diamonds': typeof AuthedDiamondsRoute;
  '/_authed/exchange-rates': typeof AuthedExchangeRatesRoute;
  '/_authed/help': typeof AuthedHelpRoute;
  '/_authed/operations': typeof AuthedOperationsRoute;
  '/_authed/organizations': typeof AuthedOrganizationsRouteWithChildren;
  '/_authed/settings': typeof AuthedSettingsRoute;
  '/_authed/support-sessions': typeof AuthedSupportSessionsRoute;
  '/_authed/users': typeof AuthedUsersRoute;
  '/_authed/account/security': typeof AuthedAccountSecurityRoute;
  '/_authed/applications/$applicationId': typeof AuthedApplicationsApplicationIdRoute;
  '/_authed/organizations/$organizationId': typeof AuthedOrganizationsOrganizationIdRoute;
  '/_authed/applications/': typeof AuthedApplicationsIndexRoute;
  '/_authed/organizations/': typeof AuthedOrganizationsIndexRoute;
  '/(public)/auth/google/callback': typeof publicAuthGoogleCallbackRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/magic-link'
    | '/reset-password'
    | '/sign-in-link'
    | '/applications'
    | '/audit-log'
    | '/diamonds'
    | '/exchange-rates'
    | '/help'
    | '/operations'
    | '/organizations'
    | '/settings'
    | '/support-sessions'
    | '/users'
    | '/account/security'
    | '/applications/$applicationId'
    | '/organizations/$organizationId'
    | '/applications/'
    | '/organizations/'
    | '/auth/google/callback';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/magic-link'
    | '/reset-password'
    | '/sign-in-link'
    | '/audit-log'
    | '/diamonds'
    | '/exchange-rates'
    | '/help'
    | '/operations'
    | '/settings'
    | '/support-sessions'
    | '/users'
    | '/account/security'
    | '/applications/$applicationId'
    | '/organizations/$organizationId'
    | '/applications'
    | '/organizations'
    | '/auth/google/callback';
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/(public)/forgot-password'
    | '/(public)/login'
    | '/(public)/magic-link'
    | '/(public)/reset-password'
    | '/(public)/sign-in-link'
    | '/_authed/applications'
    | '/_authed/audit-log'
    | '/_authed/diamonds'
    | '/_authed/exchange-rates'
    | '/_authed/help'
    | '/_authed/operations'
    | '/_authed/organizations'
    | '/_authed/settings'
    | '/_authed/support-sessions'
    | '/_authed/users'
    | '/_authed/account/security'
    | '/_authed/applications/$applicationId'
    | '/_authed/organizations/$organizationId'
    | '/_authed/applications/'
    | '/_authed/organizations/'
    | '/(public)/auth/google/callback';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthedRoute: typeof AuthedRouteWithChildren;
  publicForgotPasswordRoute: typeof publicForgotPasswordRoute;
  publicLoginRoute: typeof publicLoginRoute;
  publicMagicLinkRoute: typeof publicMagicLinkRoute;
  publicResetPasswordRoute: typeof publicResetPasswordRoute;
  publicSignInLinkRoute: typeof publicSignInLinkRoute;
  publicAuthGoogleCallbackRoute: typeof publicAuthGoogleCallbackRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed': {
      id: '/_authed';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/forgot-password': {
      id: '/(public)/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof publicForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/login': {
      id: '/(public)/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof publicLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/magic-link': {
      id: '/(public)/magic-link';
      path: '/magic-link';
      fullPath: '/magic-link';
      preLoaderRoute: typeof publicMagicLinkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/reset-password': {
      id: '/(public)/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof publicResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/sign-in-link': {
      id: '/(public)/sign-in-link';
      path: '/sign-in-link';
      fullPath: '/sign-in-link';
      preLoaderRoute: typeof publicSignInLinkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed/applications': {
      id: '/_authed/applications';
      path: '/applications';
      fullPath: '/applications';
      preLoaderRoute: typeof AuthedApplicationsRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/audit-log': {
      id: '/_authed/audit-log';
      path: '/audit-log';
      fullPath: '/audit-log';
      preLoaderRoute: typeof AuthedAuditLogRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/diamonds': {
      id: '/_authed/diamonds';
      path: '/diamonds';
      fullPath: '/diamonds';
      preLoaderRoute: typeof AuthedDiamondsRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/exchange-rates': {
      id: '/_authed/exchange-rates';
      path: '/exchange-rates';
      fullPath: '/exchange-rates';
      preLoaderRoute: typeof AuthedExchangeRatesRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/help': {
      id: '/_authed/help';
      path: '/help';
      fullPath: '/help';
      preLoaderRoute: typeof AuthedHelpRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/operations': {
      id: '/_authed/operations';
      path: '/operations';
      fullPath: '/operations';
      preLoaderRoute: typeof AuthedOperationsRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/organizations': {
      id: '/_authed/organizations';
      path: '/organizations';
      fullPath: '/organizations';
      preLoaderRoute: typeof AuthedOrganizationsRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/settings': {
      id: '/_authed/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof AuthedSettingsRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/support-sessions': {
      id: '/_authed/support-sessions';
      path: '/support-sessions';
      fullPath: '/support-sessions';
      preLoaderRoute: typeof AuthedSupportSessionsRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/users': {
      id: '/_authed/users';
      path: '/users';
      fullPath: '/users';
      preLoaderRoute: typeof AuthedUsersRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/account/security': {
      id: '/_authed/account/security';
      path: '/account/security';
      fullPath: '/account/security';
      preLoaderRoute: typeof AuthedAccountSecurityRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/applications/': {
      id: '/_authed/applications/';
      path: '/';
      fullPath: '/applications/';
      preLoaderRoute: typeof AuthedApplicationsIndexRouteImport;
      parentRoute: typeof AuthedApplicationsRoute;
    };
    '/_authed/applications/$applicationId': {
      id: '/_authed/applications/$applicationId';
      path: '/$applicationId';
      fullPath: '/applications/$applicationId';
      preLoaderRoute: typeof AuthedApplicationsApplicationIdRouteImport;
      parentRoute: typeof AuthedApplicationsRoute;
    };
    '/_authed/organizations/': {
      id: '/_authed/organizations/';
      path: '/';
      fullPath: '/organizations/';
      preLoaderRoute: typeof AuthedOrganizationsIndexRouteImport;
      parentRoute: typeof AuthedOrganizationsRoute;
    };
    '/_authed/organizations/$organizationId': {
      id: '/_authed/organizations/$organizationId';
      path: '/$organizationId';
      fullPath: '/organizations/$organizationId';
      preLoaderRoute: typeof AuthedOrganizationsOrganizationIdRouteImport;
      parentRoute: typeof AuthedOrganizationsRoute;
    };
    '/(public)/auth/google/callback': {
      id: '/(public)/auth/google/callback';
      path: '/auth/google/callback';
      fullPath: '/auth/google/callback';
      preLoaderRoute: typeof publicAuthGoogleCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

interface AuthedApplicationsRouteChildren {
  AuthedApplicationsApplicationIdRoute: typeof AuthedApplicationsApplicationIdRoute;
  AuthedApplicationsIndexRoute: typeof AuthedApplicationsIndexRoute;
}

const AuthedApplicationsRouteChildren: AuthedApplicationsRouteChildren = {
  AuthedApplicationsApplicationIdRoute: AuthedApplicationsApplicationIdRoute,
  AuthedApplicationsIndexRoute: AuthedApplicationsIndexRoute,
};

const AuthedApplicationsRouteWithChildren =
  AuthedApplicationsRoute._addFileChildren(AuthedApplicationsRouteChildren);

interface AuthedOrganizationsRouteChildren {
  AuthedOrganizationsOrganizationIdRoute: typeof AuthedOrganizationsOrganizationIdRoute;
  AuthedOrganizationsIndexRoute: typeof AuthedOrganizationsIndexRoute;
}

const AuthedOrganizationsRouteChildren: AuthedOrganizationsRouteChildren = {
  AuthedOrganizationsOrganizationIdRoute:
    AuthedOrganizationsOrganizationIdRoute,
  AuthedOrganizationsIndexRoute: AuthedOrganizationsIndexRoute,
};

const AuthedOrganizationsRouteWithChildren =
  AuthedOrganizationsRoute._addFileChildren(AuthedOrganizationsRouteChildren);

interface AuthedRouteChildren {
  AuthedApplicationsRoute: typeof AuthedApplicationsRouteWithChildren;
  AuthedAuditLogRoute: typeof AuthedAuditLogRoute;
  AuthedDiamondsRoute: typeof AuthedDiamondsRoute;
  AuthedExchangeRatesRoute: typeof AuthedExchangeRatesRoute;
  AuthedHelpRoute: typeof AuthedHelpRoute;
  AuthedOperationsRoute: typeof AuthedOperationsRoute;
  AuthedOrganizationsRoute: typeof AuthedOrganizationsRouteWithChildren;
  AuthedSettingsRoute: typeof AuthedSettingsRoute;
  AuthedSupportSessionsRoute: typeof AuthedSupportSessionsRoute;
  AuthedUsersRoute: typeof AuthedUsersRoute;
  AuthedAccountSecurityRoute: typeof AuthedAccountSecurityRoute;
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedApplicationsRoute: AuthedApplicationsRouteWithChildren,
  AuthedAuditLogRoute: AuthedAuditLogRoute,
  AuthedDiamondsRoute: AuthedDiamondsRoute,
  AuthedExchangeRatesRoute: AuthedExchangeRatesRoute,
  AuthedHelpRoute: AuthedHelpRoute,
  AuthedOperationsRoute: AuthedOperationsRoute,
  AuthedOrganizationsRoute: AuthedOrganizationsRouteWithChildren,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedSupportSessionsRoute: AuthedSupportSessionsRoute,
  AuthedUsersRoute: AuthedUsersRoute,
  AuthedAccountSecurityRoute: AuthedAccountSecurityRoute,
};

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  publicForgotPasswordRoute: publicForgotPasswordRoute,
  publicLoginRoute: publicLoginRoute,
  publicMagicLinkRoute: publicMagicLinkRoute,
  publicResetPasswordRoute: publicResetPasswordRoute,
  publicSignInLinkRoute: publicSignInLinkRoute,
  publicAuthGoogleCallbackRoute: publicAuthGoogleCallbackRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
